import { render, staticRenderFns } from "./Case.vue?vue&type=template&id=b17cdb3a&scoped=true&"
import script from "./Case.vue?vue&type=script&lang=js&"
export * from "./Case.vue?vue&type=script&lang=js&"
import style0 from "./Case.vue?vue&type=style&index=0&id=b17cdb3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b17cdb3a",
  null
  
)

export default component.exports